import type { ComponentPropsWithoutRef } from 'react'
import { useIntl } from '@/intl'
import { useEnv } from '@/scopes/common/infrastructure/env'
import { tok } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { styled, useTheme } from 'styled-components'

interface SlideFallbackProps extends ComponentPropsWithoutRef<'a'> {
  imageIndex: number
}

interface SlideFallbackStyleProps {
  $imageSource?: string
}

const StyledError = styled.a<SlideFallbackStyleProps>`
  align-items: center;
  background: ${tok('semantics_views_tinted_background_color')};
  background: url(${({ $imageSource }) => $imageSource}) no-repeat center/cover;
  color: ${tok('semantics_content_white_color')};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  //TODO: Check with Bart this rgba was a token
  text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
  width: 100%;
`

const StyledTypography = styled(Typography)`
  margin-top: ${tok('primitives_space_16')};
`

function SlideFallback({ imageIndex, ...attributes }: SlideFallbackProps) {
  const { themeName } = useTheme()
  const intl = useIntl()
  const mediaServerBaseUrl = useEnv('MEDIA_SERVER_BASE_URL') // URL to the theme specific static assets
  /**
   * Get the fallback image source based on the index of the result item
   * as design wants to mix the fallback images.
   */
  const getFallbackImageSource = (x: number) => {
    // Get a number between 1 and 3 based on the index
    const numberBetweenOneAndThree = 1 + (x % 3)
    return {
      mediaBaseUrl: mediaServerBaseUrl || '/',
      imageSource: `productcard-default-${numberBetweenOneAndThree}${themeName === 'sunweb-sun' ? `-1` : ''}.png`,
    }
  }

  const fallbackImage = getFallbackImageSource(imageIndex)
  const imageUrl = `${fallbackImage.mediaBaseUrl}/${fallbackImage.imageSource}`

  return (
    <StyledError $imageSource={imageUrl} {...attributes}>
      <StyledTypography $variant="body-l-bold-tight">
        {intl.formatMessage({
          id: 'no_image',
        })}
      </StyledTypography>
    </StyledError>
  )
}
SlideFallback.displayName = 'ImageCarouselSlideFallback'

export const ImageCarouselSlideFallback = styled(SlideFallback)``
